import PageShell from "@/components/PageShell";
import useSEO, { orgSchema, breadcrumbSchema } from "@/lib/useSEO";

export default function Terms() {
  useSEO({
    title: "Terms of Service — PixelEmpire AI",
    description:
      "Terms of service governing use of PixelEmpire AI, the permanent digital advertising grid. Fair, plain-English legal terms.",
    path: "/terms",
    jsonLd: [
      orgSchema,
      breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Terms", url: "/terms" },
      ]),
    ],
  });

  return (
    <PageShell testId="page-terms">
      <div className="pill" data-testid="terms-pill"><span>Legal · Terms</span></div>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl leading-tight text-white" data-testid="terms-h1">
        Terms of Service
      </h1>
      <p className="mt-4 text-sm text-[var(--fg-muted)]">Last updated: February 2026</p>

      <div className="mt-8 space-y-6 text-[var(--fg-muted)] leading-relaxed">
        <section>
          <h2 className="font-display text-2xl text-white">1. Overview</h2>
          <p className="mt-3">
            By using PixelEmpire AI (the "Service") you agree to these Terms. If you don't agree,
            don't use the Service.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">2. Accounts</h2>
          <p className="mt-3">
            You're responsible for keeping your login credentials safe and for all activity under
            your account. Registration requires accurate contact info.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">3. Payment & permanence</h2>
          <p className="mt-3">
            Blocks are sold as one-time purchases for lifetime placement while the Service exists.
            All sales are final except as described in section 6 (Refunds). Prices are stated in
            USD unless otherwise noted.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">4. Acceptable content</h2>
          <p className="mt-3">
            You retain all rights to the logos, images, and text you upload. You grant us a
            non-exclusive license to display them within the Service. You must not upload content
            that is illegal, defamatory, pornographic, hateful, violates any third-party rights,
            promotes weapons or drugs, or contains malware.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">5. Moderation</h2>
          <p className="mt-3">
            We reserve the right to remove ads that violate Section 4 without refund. We'll notify
            you and give you a reasonable opportunity to fix the issue where possible.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">6. Refunds</h2>
          <p className="mt-3">
            Full refund within 30 days of a paid claim if we can't publish your ad or if you
            haven't yet received traffic. After 30 days refunds are considered case-by-case,
            usually only for platform errors.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">7. Liability</h2>
          <p className="mt-3">
            The Service is provided "as is." To the maximum extent permitted by law our aggregate
            liability is capped at the total amount you've paid us in the preceding 12 months.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">8. Changes</h2>
          <p className="mt-3">
            We may update these Terms occasionally. Material changes will be announced to users at
            least 30 days in advance via email or a site banner.
          </p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-white">9. Contact</h2>
          <p className="mt-3">
            Questions: <a href="mailto:legal@pixel-empires.com" className="text-cyan-300 underline">legal@pixel-empires.com</a>
          </p>
        </section>
      </div>
    </PageShell>
  );
}
